import useChangeDocumentTitle from "hooks/use-change-document-title";

export function QuoteFiles(){
    useChangeDocumentTitle(`Files`)
    return (
        <div>
            QuoteFiles
        </div>
    )
}